
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Logout() {
  const [countdown, setCountdown] = useState(3);
  const navigate = useNavigate();

  useEffect(() => {
    // Supprimer les données de l'utilisateur connecté
    localStorage.removeItem('currentUser');
    
    // Décompte avant redirection
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleImmediateRedirect = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-logout-box-line text-white text-2xl"></i>
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Déconnexion réussie</h1>
          
          <p className="text-gray-600 mb-6">
            Vous avez été déconnecté avec succès de votre session CRM.
          </p>
          
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <div className="flex items-center justify-center space-x-2 text-gray-700">
              <i className="ri-time-line text-lg"></i>
              <span>Redirection dans {countdown} seconde{countdown > 1 ? 's' : ''}</span>
            </div>
            
            <div className="w-full bg-gray-200 rounded-full h-2 mt-3">
              <div 
                className="bg-red-500 h-2 rounded-full transition-all duration-1000"
                style={{ width: `${((3 - countdown) / 3) * 100}%` }}
              ></div>
            </div>
          </div>
          
          <button
            onClick={handleImmediateRedirect}
            className="w-full bg-red-500 hover:bg-red-600 text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Retourner à la connexion maintenant
          </button>
          
          <div className="mt-4 text-sm text-gray-500">
            <i className="ri-shield-check-line mr-1"></i>
            Vos données ont été sécurisées
          </div>
        </div>
      </div>
    </div>
  );
}